module.exports = __webpack_public_path__ + "img/table cloth.0e37c9d5.svg";